import React from 'react';
import { Helmet } from 'react-helmet';

const PageMetaData = ({ setting, isProduct }) => {
  return (
    <Helmet>
      {/* SEO Meta Tags */}
      {setting.gaDescription && (
        <meta name='description' content={setting.gaDescription} />
      )}
      {setting.gaKeywords && (
        <meta name='keywords' content={setting.gaKeywords} />
      )}
      {/* Open Graph Meta Tags */}
      {setting.gaDescription && (
        <meta property='og:description' content={setting.gaDescription} />
      )}
      {setting.seoTitle && <title>{setting.seoTitle}</title>}
      {isProduct && setting.name && (
        <meta property='og:title' content={setting.seoTitle ?? setting.name} />
      )}
      {isProduct && setting.name && <title>{setting.name}</title>}
      {isProduct && setting.pictures && setting.pictures[0] && (
        <meta property='og:image' content={setting.pictures[0].imgixUrl} />
      )}
    </Helmet>
  );
};

export default PageMetaData;
